/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Offline_Kind_Exclusion_AddInputs */

const en_us2_offline_kind_exclusion_add = /** @type {(inputs: Offline_Kind_Exclusion_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercise you no longer want`)
};

const pt_br2_offline_kind_exclusion_add = /** @type {(inputs: Offline_Kind_Exclusion_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício que você não quer mais`)
};

const es_419_offline_kind_exclusion_add = /** @type {(inputs: Offline_Kind_Exclusion_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ejercicio que ya no quieres`)
};

const pt_pt2_offline_kind_exclusion_add = /** @type {(inputs: Offline_Kind_Exclusion_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercício que já não queres`)
};

const fr_fr2_offline_kind_exclusion_add = /** @type {(inputs: Offline_Kind_Exclusion_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Exercice que tu ne veux plus`)
};

const de_de2_offline_kind_exclusion_add = /** @type {(inputs: Offline_Kind_Exclusion_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung, die du nicht mehr willst`)
};

const it_it2_offline_kind_exclusion_add = /** @type {(inputs: Offline_Kind_Exclusion_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Esercizio che non vuoi più`)
};

/**
* | output |
* | --- |
* | "Exercise you no longer want" |
*
* @param {Offline_Kind_Exclusion_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const offline_kind_exclusion_add = /** @type {((inputs?: Offline_Kind_Exclusion_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Offline_Kind_Exclusion_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_offline_kind_exclusion_add(inputs)
	if (locale === "es-419") return es_419_offline_kind_exclusion_add(inputs)
	if (locale === "pt-PT") return pt_pt2_offline_kind_exclusion_add(inputs)
	if (locale === "fr-FR") return fr_fr2_offline_kind_exclusion_add(inputs)
	if (locale === "de-DE") return de_de2_offline_kind_exclusion_add(inputs)
	if (locale === "it-IT") return it_it2_offline_kind_exclusion_add(inputs)
	return en_us2_offline_kind_exclusion_add(inputs)
});
export { offline_kind_exclusion_add as "offline.kind_exclusion_add" }